import { Checkbox, Col, Form, Input, Menu, Radio, Row, Select, Switch, Button, message, Space } from 'antd'
import Text from 'antd/lib/typography/Text';
import React, { useEffect, useState } from 'react'
import { usePersistedStore } from '../../store/persisted-store'
import { useLocation } from 'react-router-dom';
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import ValidatorHelper from '../helpers/ValidatorHelper';

const BusinessSettings = (props) => {
    const [form] = Form.useForm();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const { business, getBusinesses, putBusiness } = usePersistedStore();
    const currentBusiness = business.businesses?.byToken;


    const {
        tabId,
        copyrightState,
        setCopyrightState,
        tabState,
        handleTabChange,
        showInfoItems,
        currentLocation,
        userResources,
        ItemLayoutCols,
        styleBannersLinkLayout,
        styleTabLayout,
        aElementDownloadItems,
        homeStyleItems,
        alignmentItems,
        htmlDisable,
        textDisable,
        radioLayout,
        footerToggleChange,
        bulletOutlineInDesktop,
        bulletOutlineInMobile,
        roundBulletInDesktop,
        roundBulletInMobile,
        bulletTextOutInDesktop,
        bulletTextOutInMobile,
        setRoundBulletInDesktop,
        setBulletTextOutInDesktop,
        setBulletOutlineInDesktop,
        setRoundBulletInMobile,
        setBulletTextOutInMobile,
        setBulletOutlineInMobile,
        layout
    } = props;

    useEffect(() => {
        form.setFieldsValue({
            ...currentBusiness,
            pwaEnabled: currentBusiness?.PwaEnabled,
            phones: currentBusiness?.phone
                ? currentBusiness.phone.split(',').map(p => p.trim())
                : [''],
            addresses: currentBusiness?.address
                ? currentBusiness.address
                    .split(/\|\|\||\\n|\n/)  // Split by either ||| or \\n
                    .map(a => a.trim())
                    .filter(a => a)
                : ['']
        });
    }, [currentBusiness, form, location.pathname]);


    const onFinish = async (values) => {
        try {
            setLoading(true);
            if (htmlDisable) {
                values.footerHtml = "";
            }

            if (!values.name) {
                message.error({
                    content: ' عنوان شریک تجاری  را در اطلاعات پایه وارد کنید ',
                    style: {
                        marginTop: '20vh',
                    }
                });
                return
            }
            if (!values.domain) {
                message.error({
                    content: 'آدرس دامنه را در اطلاعات پایه وارد کنید',
                    style: {
                        marginTop: '20vh',
                    }
                });
                return
            }
            if (!values.token) {
                message.error({
                    content: '  توکن را در اطلاعات پایه وارد کنید',
                    style: {
                        marginTop: '20vh',
                    }
                });
                return
            }

            const phone = values.phones?.filter(p => p && p.trim()).join(',') || '';
            const address = values.addresses?.filter(a => a && a.trim()).join('|||') || '';

            // Filter out fields that should not be included in the API call
            const settingsData = {
                // Basic Info
                id: currentBusiness?.id,
                name: values.name,
                domain: values.domain,
                token: values.token,
                Title: values.Title,
                imageTitle: values.imageTitle,
                raychatId: values.raychatId,
                samandehi: values.samandehi,
                enamad: values.enamad,
                eanjoman: values.eanjoman,
                headerTags: values.headerTags,

                // Contact Info
                phone: phone,
                address: address,
                email: values.email,
                postalCode: values.postalCode,

                // Settings
                follow: values.follow,
                guide: values.guide,
                layout: values.layout,
                login: values.login,
                copyright: values.copyright,
                showCompanies: values.showCompanies,
                debug: values.debug,
                forceLogin: values.forceLogin,
                gdprCompliant: values.gdprCompliant,
                showVoucherBoxInPlanList: values.showVoucherBoxInPlanList,
                showVoucherBoxInPrePayment: values.showVoucherBoxInPrePayment,
                PwaEnabled: values.pwaEnabled,
                aElementDownloadType: values.aElementDownloadType,
                HomeStyle: values.HomeStyle,
                bannersLink: values.bannersLink,
                TagmanagerCode: values.TagmanagerCode,
                footerText: values.footerText,
                footerHtml: htmlDisable ? '' : values.footerHtml,

                // Tech Settings (if user has permission)
                showBranchHome: values.showBranchHome,
                showBimehContent: values.showBimehContent,
                showChatBox: values.showChatBox,
                IsCredit: values.IsCredit,

                // Desktop View
                IntroGridDesktop: values.IntroGridDesktop,
                titleInDesktop: values.titleInDesktop,
                headerInDesktop: values.headerInDesktop,
                footerInDesktop: values.footerInDesktop,
                badgeInDesktop: values.badgeInDesktop,
                servicesInDesktop: values.servicesInDesktop,
                blogInDesktop: values.blogInDesktop,
                roundBulletInDesktop: values.roundBulletInDesktop,
                bulletTextOutInDesktop: values.bulletTextOutInDesktop,
                outlineBulletInDesktop: values.outlineBulletInDesktop,
                showDesktopBanner: values.showDesktopBanner,
                alignment: typeof values.alignment === "undefined" ? 2 : values?.alignment,
                subTitleInDesktop: values.subTitleInDesktop,
                aboutInDesktop: values.aboutInDesktop,

                // Mobile View
                IntroGridMobile: values.IntroGridMobile,
                titleInMobile: values.titleInMobile,
                headerInMobile: values.headerInMobile,
                footerInMobile: values.footerInMobile,
                badgeInMobile: values.badgeInMobile,
                serviceInMobile: values.servicesInMobile,
                blogInMobile: values.blogInMobile,
                roundBulletInMobile: values.roundBulletInMobile,
                bulletTextOutInMobile: values.bulletTextOutInMobile,
                outlineBulletInMobile: values.outlineBulletInMobile,
                showMobileBanner: values.showMobileBanner,
                subTitleInMobile: values.subTitleInMobile,
                aboutInMobile: values.aboutInMobile,
            };

            await putBusiness(settingsData);
            setTimeout(() => {
                getBusinesses()
            }, 500)
        } catch (error) {
            console.error('Error updating business settings:', error);
            message.error(error?.response?.data?.message || 'خطا در بروزرسانی تنظیمات');
        } finally {
            setLoading(false);
        }
    };

    return (

        <div>
            <Menu
                className="business-form-menu mt-0"
                onClick={handleTabChange} selectedKeys={[tabState]} mode="horizontal">
                {showInfoItems && !currentLocation && <Menu.Item key="initialInfo">
                    اطلاعات پایه
                </Menu.Item>}
                <Menu.Item key="contactInfo">
                    اطلاعات تماس
                </Menu.Item>
                {!currentLocation && <Menu.Item key="setting">
                    تنظیمات
                </Menu.Item>}
                <Menu.Item key="DesktopView">
                    دسکتاپ
                </Menu.Item>
                <Menu.Item key="MobileAndTabletView">
                    موبایل و تبلت
                </Menu.Item>
            </Menu>
            <Form
                form={form}
                {...layout}
                layout="horizontal"
                name="add_company"
                className='business-form'
                onFinish={onFinish}
            >
                <div className={`tabViewPort ${(tabState === "initialInfo" && tabId === "1") ? 'visibleTab' : null}`}>

                    <Form.Item className="formItem" name="name" label="عنوان شریک تجاری"
                        rules={[{ required: true, message: 'لطفا عنوان شریک تجاری  را  وارد کنید.' }]}>
                        <Text style={{ color: "var(--text-strong)" }}>{currentBusiness?.name}</Text>
                        <Input style={{ display: 'none' }} />
                    </Form.Item>
                    <Form.Item className="formItem" name="domain" label="آدرس دامنه"
                        rules={[{ required: true, message: 'لطفا آدرس دامنه را  وارد کنید.' }]} >
                        <Text style={{ color: "var(--text-strong)" }}>{currentBusiness?.domain}</Text>
                        <Input style={{ display: 'none' }} />
                    </Form.Item>
                    <Form.Item className="formItem" name="token" label="توکن"
                        rules={[{ required: true, message: 'لطفا توکن را  وارد کنید.' }]}>
                        <Text style={{ color: "var(--text-strong)" }}>{currentBusiness?.token}</Text>
                        <Input style={{ display: 'none' }} />
                    </Form.Item>
                    <Form.Item className="formItem" name="Title" label="عنوان اصلی">
                        <Input />
                    </Form.Item>
                    <Form.Item className="formItem" name="imageTitle" label="آدرس تصویر بجای عنوان">
                        <Input />
                    </Form.Item>
                    <Form.Item className="formItem" name="raychatId" label="آی دی رایچت">
                        <Input />
                    </Form.Item>
                    <Form.Item className="formItem" name="samandehi" label="آی دی ساماندهی"
                        extra="درصورت استفاده از فوتر داینامیک این فیلد غیر قابل استفاده خواهد بود">
                        <Input />
                    </Form.Item>
                    <Form.Item className="formItem" name="enamad" label="آی دی اینماد"
                        extra="درصورت استفاده از فوتر داینامیک این فیلد غیر قابل استفاده خواهد بود">
                        <Input />
                    </Form.Item>
                    <Form.Item className="formItem" name="eanjoman" label="آی دی ای انجمن"
                        extra="درصورت استفاده از فوتر داینامیک این فیلد غیر قابل استفاده خواهد بود">
                        <Input />
                    </Form.Item>
                    <Row>
                        <Col md={12} xs={24}>
                            {userResources && userResources?.includes("business-tech-setting") &&
                                <Form.Item className="formItem"
                                    name="showBranchHome" valuePropName="checked">
                                    <Checkbox>نمایش هوم رشته ها</Checkbox>
                                </Form.Item>}
                            {userResources && userResources?.includes("business-tech-setting") &&
                                <Form.Item className="formItem"
                                    name="showBimehContent" valuePropName="checked">
                                    <Checkbox>نمایش محتوای بیمه‌دات کام</Checkbox>
                                </Form.Item>}
                        </Col>
                        <Col md={12} xs={24}>
                            {userResources && userResources?.includes("business-tech-setting") &&
                                <Form.Item className="formItem"
                                    name="showChatBox" valuePropName="checked">
                                    <Checkbox>دستیار هوش مصنوعی</Checkbox>
                                </Form.Item>}

                            {userResources && userResources?.includes("business-tech-setting") &&
                                <Form.Item className="formItem"
                                    name="IsCredit" valuePropName="checked">
                                    <Checkbox>تفکیک درگاه های شتابی و اعتباری</Checkbox>
                                </Form.Item>}
                        </Col>
                    </Row>
                    <Form.Item className="formItem" name="headerTags" label="متا تگ ها جهت درج در تگ <Head>">
                        <Input.TextArea rows={5} />
                    </Form.Item>
                </div>
                <div className={`tabViewPort ${(tabState === "contactInfo" && tabId === "1") ? 'visibleTab' : null}`}>
                    <Form.List name="phones">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item
                                        key={field.key}
                                        label={index === 0 ? "شماره تماس" : <span style={{ display: 'inline-block', minWidth: '100%' }}>&nbsp;</span>}
                                        colon={index === 0}
                                        required={index === 0}
                                        extra={
                                            index === 0 ? (
                                                <ul style={{ margin: 0, paddingRight: 16 }}>
                                                    <li>برای درج چند شماره تماس، از دکمه + استفاده کنید (حداکثر 5 شماره)</li>
                                                    <li>شماره تماس اول به عنوان شماره پیش‌فرض تماس در دستگاه کاربران نمایش داده می‌شود.</li>
                                                </ul>
                                            ) : null
                                        }
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Form.Item
                                                {...field}
                                                noStyle
                                                rules={[{ required: index === 0, message: "شماره تماس را وارد کنید" }, ...ValidatorHelper.number("شماره تماس")]}
                                            >
                                                <Input />
                                            </Form.Item>
                                            {fields.length < 5 && index === fields.length - 1 && (
                                                <Button
                                                    type="dashed"
                                                    icon={<PlusOutlined />}
                                                    onClick={() => add()}
                                                    style={{ flexShrink: 0 }}
                                                />
                                            )}
                                            {fields.length > 1 && (
                                                <MinusCircleOutlined
                                                    onClick={() => remove(field.name)}
                                                    style={{ color: "red", fontSize: 24, flexShrink: 0 }}
                                                />
                                            )}
                                        </div>
                                    </Form.Item>
                                ))}
                            </>
                        )}
                    </Form.List>

                    <Form.Item className="formItem" name="email" label="پست الکترونیکی">
                        <Input />
                    </Form.Item>

                    <Form.List name="addresses">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item
                                        key={field.key}
                                        label={index === 0 ? "آدرس" : <span style={{ display: 'inline-block', minWidth: '100%' }}>&nbsp;</span>}
                                        colon={index === 0}
                                        extra={index === 0 ? "برای درج چند آدرس، از دکمه + استفاده کنید (حداکثر ۲ آدرس)" : null}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Form.Item {...field} noStyle>
                                                <Input />
                                            </Form.Item>
                                            {fields.length < 2 && index === fields.length - 1 && (
                                                <Button
                                                    type="dashed"
                                                    icon={<PlusOutlined />}
                                                    onClick={() => add()}
                                                    style={{ flexShrink: 0 }}
                                                />
                                            )}
                                            {fields.length > 1 && (
                                                <MinusCircleOutlined
                                                    onClick={() => remove(field.name)}
                                                    style={{ color: "red", fontSize: 24, flexShrink: 0 }}
                                                />
                                            )}
                                        </div>
                                    </Form.Item>
                                ))}
                            </>
                        )}
                    </Form.List>

                    <Form.Item className="formItem" name="postalCode" label="کد پستی" >
                        <Input />
                    </Form.Item>
                </div>
                <div className={`tabViewPort ${(tabState === "setting" && tabId === "1") ? 'visibleTab' : null}`}>
                    <Row>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="follow" valuePropName="checked">
                                <Checkbox>از موتورهای جستجو درخواست کن تا محتوای سایت را بررسی کنند</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="guide" valuePropName="checked">
                                <Checkbox>نمایش راهنمای خرید رشته‌ها</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="layout" valuePropName="checked">
                                <Checkbox disabled={currentBusiness?.isBimeh}>صفحه اصلی ندارد (صفحه ی اصلی توسط شریک تجاری پیاده سازی شده است)</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="login" valuePropName="checked">
                                <Checkbox disabled={currentBusiness?.isBimeh}>استفاده از سرویس لاگین (در صورت عدم انتخاب باید سرویس اوتولاگین پیاده سازی شود)</Checkbox>
                            </Form.Item>
                        </Col>
                        {/* <Col {...ItemLayoutCols}>
                        <Form.Item className="formItem" name="userRegistration" valuePropName="checked">
                            <Checkbox>فعال بودن سرویس ثبت نام</Checkbox>
                        </Form.Item>
                    </Col> */}
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="copyright">
                                <Checkbox onChange={event => setCopyrightState(event.target.checked)} checked={copyrightState}
                                >نمایش کپی رایت در فوتر</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="showCompanies" valuePropName="checked">
                                <Checkbox >نمایش لوگوی شرکت های بیمه در صفحه ی اول</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="debug" valuePropName="checked">
                                <Checkbox>فعال بودن حالت دیباگ</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="marketerSystem" valuePropName="checked">
                                <Checkbox disabled>فعال شدن سرویس بازاریاب</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="hasTicketingService" valuePropName="checked">
                                <Checkbox disabled>فعال شدن سیستم تیکت</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="onlyOtpLogin" valuePropName="checked">
                                <Checkbox disabled>ورود تنها با OTP</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="allowUseReminders" valuePropName="checked">
                                <Checkbox disabled>نمایش لینک صفحه ی یادآور بیمه در منو</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="forceLogin" valuePropName="checked">
                                <Checkbox>لاگین اجباری</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="showVoucherBoxInPlanList" valuePropName="checked">
                                <Checkbox>باکس کد تخفیف در پلن لیست</Checkbox>
                            </Form.Item>
                        </Col>

                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="showVoucherBoxInPrePayment" valuePropName="checked">
                                <Checkbox>باکس کد تخفیف در مرحله پرداخت</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="gdprCompliant" valuePropName="checked">
                                <Checkbox>فعال شدن نمایش کوکی</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem" name="pwaEnabled" valuePropName="checked">
                                <Checkbox>فعال سازی PWA</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    {userResources && userResources?.includes("business-tech-setting") &&
                        <Form.Item
                            {...styleBannersLinkLayout}
                            name="HomeStyle"
                            label="استایل صفحه اصلی">
                            <Select placeholder="استایل صفحه اصلی" initialValues={currentBusiness?.HomeStyle} >
                                {homeStyleItems?.map((item, index) => {
                                    return <Select.Option key={index} value={item.value}>
                                        {item.title}
                                    </Select.Option>;
                                }
                                )}
                            </Select>
                        </Form.Item>}
                    <Form.Item
                        {...styleBannersLinkLayout}
                        name="aElementDownloadType"
                        label="روش دانلود بیمه نامه">
                        <Select placeholder="دانلود با سرویس JSON" initialValues={currentBusiness?.aElementDownloadType} >
                            {aElementDownloadItems?.map((item, index) =>
                                <Select.Option key={index} value={item.value}>
                                    {item.title}
                                </Select.Option>
                            )}
                        </Select>
                    </Form.Item>
                    <Form.Item {...styleBannersLinkLayout} className="formItem" name="bannersLink" label="لینک بنر">
                        <Input />
                    </Form.Item>
                    <Form.Item {...styleBannersLinkLayout} name="TagmanagerCode" label="tagManager-id">
                        <Input />
                    </Form.Item>

                    <Row>
                        <Col lg={10}>
                            <Form.Item {...styleTabLayout} className="formItem" name="footerText" label="متن فوتر">
                                <Input.TextArea disabled={textDisable} rows={6} />
                            </Form.Item>
                        </Col>
                        <Col lg={3}>
                            <div className="footer-swich">
                                <div>فوتر دلخواه:</div>
                                <Switch checked={!htmlDisable} onChange={footerToggleChange} />
                            </div>
                        </Col>
                        <Col lg={10}>
                            <Form.Item {...styleTabLayout} className="formItem" name="footerHtml" label="تنظیمات فوتر (کد Html)">
                                <Input.TextArea disabled={htmlDisable} rows={6} type="code" />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                <div className={`tabViewPort ${(tabState === "DesktopView" && tabId === "1") ? 'visibleTab' : null}`}>
                    <Form.Item className="formItem"
                        {...radioLayout}
                        label="تعداد ستون‌های بولت‌ها در حالت دسکتاپ"
                        name="IntroGridDesktop">
                        <Radio.Group>
                            <Radio.Button value={4}>۴</Radio.Button>
                            <Radio.Button value={6}>۶</Radio.Button>
                            <Radio.Button value={8}>۸</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    <Row>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="titleInDesktop" valuePropName="checked">
                                <Checkbox>نمایش عنوان اصلی</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="headerInDesktop" valuePropName="checked">
                                <Checkbox>نمایش هدر </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="footerInDesktop" valuePropName="checked">
                                <Checkbox>نمایش فوتر </Checkbox>
                            </Form.Item>
                        </Col>
                        {currentBusiness && currentBusiness?.isBimeh && <Col {...ItemLayoutCols}><Form.Item className="formItem"
                            name="blogInDesktop" valuePropName="checked">
                            <Checkbox>نمایش بخش بلاگ رول</Checkbox>
                        </Form.Item> </Col>}
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="badgeInDesktop" valuePropName="checked">
                                <Checkbox disabled={currentBusiness?.isBimeh}>نمایش بج تخفیف و صدور آنلاین بر روی بولت‌های صفحه اول </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="servicesInDesktop" valuePropName="checked">
                                <Checkbox>نمایش مراحل خرید بیمه در صفحه اول </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="roundBulletInDesktop" valuePropName="checked">
                                <Checkbox checked={roundBulletInDesktop} onChange={(e) => e.target.checked ? (setRoundBulletInDesktop(true), setBulletTextOutInDesktop(true), setBulletOutlineInDesktop(false)) : setRoundBulletInDesktop(false)} disabled={bulletOutlineInDesktop || currentBusiness?.isBimeh}>نمایش بولت‌ها به شکل گرد (در این حالت نام رشته بیمه خارج از بولت نمایش داده میشود)</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="bulletTextOutInDesktop" valuePropName="checked">
                                <Checkbox checked={bulletTextOutInDesktop} onChange={(e) => e.target.checked ? setBulletTextOutInDesktop(true) : setBulletTextOutInDesktop(false)} disabled={roundBulletInDesktop || currentBusiness?.isBimeh}>عنوان رشته بیمه خارج از بولت </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="outlineBulletInDesktop" valuePropName="checked">
                                <Checkbox checked={bulletOutlineInDesktop} onChange={(e) => e.target.checked ? (setBulletOutlineInDesktop(true), setRoundBulletInDesktop(false)) : setBulletOutlineInDesktop(false)} disabled={roundBulletInDesktop || currentBusiness?.isBimeh}>نمایش بولت‌ها به شکل اوت‌لاین </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="showDesktopBanner" valuePropName="checked">
                                <Checkbox>نمایش بنر آپلود شده </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                name="alignment"
                                label="نحوه استقرار آیکون ها">
                                <Select
                                    initialValues={2}
                                    placeholder="وسط چین"
                                >
                                    {alignmentItems?.map((item, index) =>
                                        <Select.Option key={index} value={item.value}>
                                            {item.title}
                                        </Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item className="formItem" name="subTitleInDesktop" label="زیر عنوان">
                        <Input />
                    </Form.Item>
                    <Form.Item className="formItem" name="aboutInDesktop" label="درباره ما">
                        <Input.TextArea rows={5} />
                    </Form.Item>
                    {/* <Form.Item className="formItem" name="footerText" label="متن فوتر">
                    <Input.TextArea rows={5} />
                </Form.Item> */}
                </div>
                <div className={`tabViewPort ${(tabState === "MobileAndTabletView" && tabId === "1") ? 'visibleTab' : null}`}>
                    <Form.Item className="formItem"
                        {...radioLayout}
                        label="تعداد ستون‌های بولت‌ها در حالت موبایل"
                        name="IntroGridMobile">
                        <Radio.Group>
                            <Radio.Button value={1}>۱</Radio.Button>
                            <Radio.Button value={2}>۲</Radio.Button>
                            <Radio.Button value={3}>۳</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    <Row>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="titleInMobile" valuePropName="checked">
                                <Checkbox>نمایش عنوان اصلی</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="headerInMobile" valuePropName="checked">
                                <Checkbox>نمایش هدر  </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="footerInMobile" valuePropName="checked">
                                <Checkbox>نمایش فوتر  </Checkbox>
                            </Form.Item>
                        </Col>
                        {currentBusiness && currentBusiness?.isBimeh && <Col {...ItemLayoutCols}><Form.Item className="formItem"
                            name="blogInMobile" valuePropName="checked">
                            <Checkbox>نمایش بخش بلاگ رول</Checkbox>
                        </Form.Item></Col>}
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="badgeInMobile" valuePropName="checked">
                                <Checkbox disabled={currentBusiness?.isBimeh}>نمایش بج تخفیف و صدور آنلاین بر روی بولت‌های صفحه اول </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="servicesInMobile" valuePropName="checked">
                                <Checkbox>نمایش مراحل خرید بیمه در صفحه اول </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="roundBulletInMobile" valuePropName="checked">
                                <Checkbox checked={roundBulletInMobile} onChange={(e) => e.target.checked ? (setRoundBulletInMobile(true), setBulletTextOutInMobile(true)) : setRoundBulletInMobile(false)} disabled={bulletOutlineInMobile || currentBusiness?.isBimeh}>نمایش بولت‌ها به شکل گرد در موبایل(در این حالت نام رشته بیمه خارج از بولت نمایش داده میشود)</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="bulletTextOutInMobile" valuePropName="checked">
                                <Checkbox checked={bulletTextOutInMobile} onChange={(e) => e.target.checked ? setBulletTextOutInMobile(true) : setBulletTextOutInMobile(false)} disabled={roundBulletInMobile || currentBusiness?.isBimeh}>عنوان رشته بیمه خارج از بولت </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="outlineBulletInMobile" valuePropName="checked">
                                <Checkbox checked={bulletOutlineInMobile} onChange={(e) => e.target.checked ? (setBulletOutlineInMobile(true), setRoundBulletInMobile(false)) : setBulletOutlineInMobile(false)} disabled={roundBulletInMobile || currentBusiness?.isBimeh}>نمایش بولت‌ها به شکل اوت‌لاین </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col {...ItemLayoutCols}>
                            <Form.Item className="formItem"
                                name="showMobileBanner" valuePropName="checked">
                                <Checkbox>نمایش بنر آپلود شده</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item
                                name="alignment"
                                label="نحوه استقرار آیکون ها">
                                <Select
                                    initialValues={2}
                                    placeholder="وسط چین"
                                >
                                    {alignmentItems?.map((item, index) =>
                                        <Select.Option key={index} value={item.value}>
                                            {item.title}
                                        </Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item className="formItem" name="subTitleInMobile" label="زیر عنوان">
                        <Input />
                    </Form.Item>
                    <Form.Item className="formItem" name="aboutInMobile" label="درباره ما">
                        <Input.TextArea rows={5} />
                    </Form.Item>
                </div>

                <div style={{
                    display: 'flex',
                    marginTop: '30px',
                    justifyContent: 'end',
                    marginLeft: '60px'
                }}>
                    <Space>
                        <Button
                            className="primary-button"
                            loading={loading}
                            onClick={() => form.submit()}
                            disabled={!currentLocation && currentLocation !== false}
                        >
                            ذخیره تغییرات
                        </Button>
                    </Space>
                </div>
            </Form >

        </div >

    )
}

export default BusinessSettings